import styled from "styled-components";

const AditionalHourTableArea = styled.div`
  margin-right: 10%;
`;

const FlexDiv = styled.div`
  display: flex;
`;

const ActionsDivContainer = styled.div`
  display: flex;
  justify-content: space-between;

  svg {
    font-size: 25px;
    cursor: pointer;
  }
`;

export { AditionalHourTableArea, FlexDiv, ActionsDivContainer };
